import { useLightContext } from 'light-component';
import { useMemo, type ReactElement } from 'react';
import styles from './style.module.less';
import type { CanvasImageProps } from './types';

export function CanvasImage(props: CanvasImageProps): ReactElement | null {
  const { baseName } = useLightContext();
  const imageUrl = useMemo(() => {
    if (props.value == null) {
      return '';
    }
    if (props.value.startsWith('http://') || props.value.startsWith('https://')) {
      return props.value;
    }

    return `${baseName}/api/oss/redirect?name=${props.value}`;
  }, [baseName, props.value]);

  if (props.isCanvas) {
    return null;
  }

  // 没有图片用空 div 显示一个空白的绘制区域
  const isEmpty = props.value == null || props.value.length === 0;
  if (isEmpty) {
    return (<div className={styles.canvas} style={{ height: props.height }} />);
  }

  // 显示图片, 需要转换src
  return (
    <img className={styles.canvas}
      src={imageUrl}
      style={{ height: props.height }}
    />
  );
}
